import EventDataLayer, { SubscriberCallback } from "../../queue/EventDataLayer";
import { processAidenOrderConfirmation } from "./mappers/AidenOrderConfirmationImpression";

const AidenSubscriber = (
    eventDataLayer: EventDataLayer,
    withHistory = false
) => {
    eventDataLayer.subscribe("aiden-subscriber", subscribe, withHistory);
};

const subscribe: SubscriberCallback = (event, data): void => {
    switch (event) {
        case "tool-laststep":
            processAidenOrderConfirmation(data);
            break;
    }
};

export { AidenSubscriber };
